import React from 'react';
import Styled from './CloseBtn.styled';
import { Icon } from '../../../atoms';
import { ComponentProps } from './CloseBtn.types';

const CloseBtn = ({ ...props }: ComponentProps) => {
  return (
    <Styled {...props}>
      <Icon type="close" color="var(--color-indigo-t11)" />
    </Styled>
  );
};

export default CloseBtn;
